import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const completedOrdersIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6625 9.14935H0.5625V2.10151C0.5625 1.45056 1.06334 0.922852 1.65348 0.922852H21.4715C22.0741 0.922852 22.5625 1.43745 22.5625 2.10151V9.14935H21.4625V20.9032C21.4625 21.5514 20.9731 22.0767 20.3698 22.0767H2.75524C2.15174 22.0767 1.6625 21.5508 1.6625 20.9032V9.14935ZM19.2625 9.14935H3.8625V19.7263H19.2625V9.14935ZM2.7625 3.27328V6.79892H20.3625V3.27328H2.7625ZM8.2625 11.4998H14.8625V13.8502H8.2625V11.4998Z"
      fill="#F26533"
    />
  </svg>
);

export const CompletedOrdersIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={completedOrdersIcon} {...props} />;
